module.exports = __webpack_public_path__ + "static/img/MU.f79feea8.svg";